import React, {useContext, useState, useEffect} from 'react';
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import utilities from '../utilities'
import useSignalR from '../Hooks/useSignalR'
import {AuthContext} from '../context/AuthContext'
import {BASE_URL} from '../config'

const PrintAdmissions = (props) => {

    const {userInfo} = useContext(AuthContext);
    const [submitting, setSubmitting] = useState(false);


    const PrintRegistraionApplicants = async() => {
        setSubmitting(true);
        const file = await utilities.downloadFile( {url: '/Registration/PrintListOfAppliedStudents', jwt: userInfo.jwt });
        const downloadUrl = window.URL.createObjectURL(file);
        window.open(downloadUrl, '__blank');
        window.URL.revokeObjectURL(downloadUrl);
        setSubmitting(false);
    

    }
    


return (
    <div className="content">
        <div className="header">
            <label className="title"> Print List of Students Applied for Registration </label>
        </div>
        <div className="body">
            <div className="animate-bottom">
                <ul>
                    <li>
                        You are requested to <span className='fw-bold'> signed and stamped it </span>  from the head of your institute 
                    </li>
                    <li>
                        And <span className='fw-bold'> dispatch the signed letter </span> to the office of Punjab Medical Faculty 
                    </li>

                </ul>

                <div>
                     <button className='btn btn-success' type='button' disabled={!userInfo.isFeePeriodExpired && !userInfo.isPortalLocked} onClick={PrintRegistraionApplicants}>
                     {submitting ? 
                      (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : 
                      (<span >Print Student List</span>)                   
                   }                      
                     </button> 
                </div>
            </div>
        </div>
    </div>


)    

};

export default PrintAdmissions;